import Styled from 'styled-components';

const Content = Styled.div`
  display:flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 16px 24px 16px;
  border-radius: 20px 20px 0px 0px;
  background-color: #FFFF;
`;

const Hr = Styled.div`
  width: 60px;
  height: 5px;
  border-radius: 47px;
  background: #9E9E9E;
`;

const Exit = Styled.div`
  display: flex;
  justify-content: center;
  padding: 8px 0 16px 0;
`;

export { Content, Hr, Exit };
